/* eslint-disable prettier/prettier */
import { request } from "../../api";
import { headers } from "../../../../config/config";
import { MESSAGE } from "../../../../constants/api/message";
import { AUTHORIZATION } from "../../../../constants/api/auth";
import { Group } from "../../../../@types/group.types";
const { post, get, patch, put, del } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "groups";

export const createGroup = async (_payload: any) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/create-groups`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response && error.response.status === 400) {
			const { message } = error.response.data;

			if (message === "Invalid Group details") {
				alert("Please fill group details correctly!");
			} else if (message === "group_name is required!") {
				alert("Group name is required!");
			} else if (message === "group_number is required!") {
				alert("Group number is required!");
			} else if (message === "Invalid ZIP code!") {
				alert("Please enter a valid ZIP code!");
			} else if (message === "Invalid email format!") {
				alert("Please enter a valid email address!");
			} else if (message === "Duplicate Group Number!") {
				alert("Group number already exists!");
			} else if (message === "Unauthorized Role!") {
				alert("Unauthorized Role!");
			} else if (message === "Failed to add activity") {
				alert("Failed to add activity log!");
			} else {
				alert("Other Errors of Status Code 400");
			}
		} else {
			throw error;
		}
	}
};

export const getGroupByGroupNumber = async (group_number: number) => {
	try {
		const endpoint = `${initialRoute}/group-by-group-number/${group_number}`;
		const token = localStorage.getItem("@jwt");
		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const editGroup = async (group_number: number, _payload: any) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/edit-group/${group_number}`;
		const token = localStorage.getItem("@jwt");
		const response = await put(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		console.log("response calling here====>", response);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.put.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const deleteGroup = async (groupNumber: number) => {
	try {
		const endpoint = `${initialRoute}/delete-group/${groupNumber}`;
		const token = localStorage.getItem("@jwt");
		const response = await del(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			return response;
		}

		throw new Error();
	} catch (err) {
		alert(err);
		throw err;
	}
};

export const updateGroupStatus = async (groupNumber: number) => {
	try {
		const endpoint = `${initialRoute}/update-status/${groupNumber}/status`;
		const token = localStorage.getItem("@jwt");
		const response = await put(
			endpoint,
			{ status: "Active" },
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			}
		);
		if (response) {
			return response;
		}

		throw new Error();
	} catch (err) {
		alert(err);
		throw err;
	}
};
